import React from 'react'
import Image from 'next/image'
import * as Types from 'declarations'
import { getUploadThumbPath } from 'lib/display'

interface Props {
	image: Types.DB.Models.UploadAttributes
	slug: string
	altText: string
	onImageClick: (imageId: number) => void
}

const SinglePicDesign = ({ image, onImageClick, altText }: Props) => {
	const src = getUploadThumbPath(image?.id ?? -1, 'large')

	// const cdnSrc = `https://www.guidedpeaks.com/cdn-cgi/image/format=auto,width=800,height=325/${src}`

	return (
		<div
			id="singlepic-design"
			style={{
				backgroundImage: `url('${src}')`,
				borderRadius: '8px',
			}}
		>
			<Image
				src={src}
				width={800}
				height={325}
				style={{
					margin: '0 auto',
					display: 'block',

					// maxHeight: '325px',
					maxHeight: '100%',
					height: '325px',
					width: 'auto',
					// objectFit: 'cover',
					// objectPosition: 'center',
				}}
				onClick={() => onImageClick(image.id)}
				alt={altText}
				title={altText}
				priority={true}
			/>
		</div>
	)
}

export default SinglePicDesign
